import { MapPin, Phone, Mail, Clock } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import ContactForm from "../components/ContactForm";
import BookCta from "../components/BookCta";
import { SITE } from "../data/site";

const INFO = [
  {
    icon: MapPin,
    label: "Studio",
    value: SITE.address,
    href: SITE.mapsLink,
    testId: "contact-address",
  },
  {
    icon: Phone,
    label: "Telefono",
    value: SITE.phone,
    href: SITE.phoneHref,
    testId: "contact-phone",
  },
  {
    icon: Mail,
    label: "Email",
    value: SITE.email,
    href: SITE.emailHref,
    testId: "contact-email",
  },
  {
    icon: Clock,
    label: "Orari",
    value: "Riceve su appuntamento — finestre dedicate ai nuovi clienti il lunedì e il mercoledì",
    testId: "contact-hours",
  },
];

const Contatti = () => (
  <>
    <Seo
      title="Contatti | Studio Legale Avv. Manfredi Bruno, Palermo"
      description="Contatta lo Studio Legale Avv. Manfredi Bruno a Palermo: Via Salvatore Meccio 22. Telefono 091 322514. Prenota un appuntamento o richiedi di essere ricontattato."
      path="/contatti"
    />
    <PageHero
      kicker="Contatti"
      title="Contatta lo studio"
      intro="Puoi prenotare un appuntamento, telefonare allo studio oppure lasciare i tuoi dati nel modulo: la segreteria ti ricontatterà per fissare un colloquio con l'Avv. Manfredi Bruno."
      breadcrumb="Contatti"
    />

    <section className="bg-white py-14 sm:py-20">
      <div className="container-site grid gap-12 lg:grid-cols-[1fr_1.2fr]">
        <div>
          <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-navy">
            {SITE.studio}
          </h2>
          <ul className="mt-6 space-y-5">
            {INFO.map((i) => (
              <li key={i.label} className="flex items-start gap-4" data-testid={i.testId}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold-soft">
                  <i.icon size={18} className="text-gold-dark" aria-hidden="true" />
                </span>
                <span>
                  <span className="block text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">
                    {i.label}
                  </span>
                  {i.href ? (
                    <a
                      href={i.href}
                      target={i.href.startsWith("http") ? "_blank" : undefined}
                      rel={i.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      className="mt-0.5 block text-sm font-medium text-navy transition-colors hover:text-gold-dark"
                    >
                      {i.value}
                    </a>
                  ) : (
                    <span className="mt-0.5 block text-sm font-medium leading-relaxed text-navy">
                      {i.value}
                    </span>
                  )}
                </span>
              </li>
            ))}
          </ul>
          <div className="mt-8">
            <BookCta testId="contacts-book-button" />
          </div>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
          <h2 className="font-serif text-2xl font-semibold text-navy">
            Richiedi di essere ricontattato
          </h2>
          <p className="mt-2 mb-7 text-sm leading-relaxed text-slate-600">
            Compila il modulo: la segreteria dello studio ti ricontatterà per fissare un
            appuntamento o rispondere alla tua richiesta.
          </p>
          <ContactForm />
        </div>
      </div>
    </section>

    <section className="bg-gold-soft py-14 sm:py-20">
      <div className="container-site grid items-center gap-8 lg:grid-cols-[1fr_1.2fr]">
        <div>
          <p className="kicker">Dove siamo</p>
          <h2 className="mt-3 font-serif text-2xl sm:text-3xl font-semibold text-navy">
            Nel cuore di Palermo
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-slate-600">
            Lo studio si trova in Via Salvatore Meccio n. 22, in una zona centrale e
            facilmente raggiungibile di Palermo. Si riceve su appuntamento.
          </p>
        </div>
        <div className="grid gap-4">
          <div className="overflow-hidden rounded-2xl border border-slate-200 shadow-lg">
            <iframe
              src={SITE.mapsEmbed}
              title="Mappa dello Studio Legale Avv. Manfredi Bruno, Via Salvatore Meccio 22, Palermo"
              data-testid="contact-map"
              className="h-72 w-full sm:h-80"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <img
            src="/images/studio-ingresso.webp"
            alt="L'ingresso dello studio legale dell'Avv. Manfredi Bruno a Palermo"
            data-testid="contact-studio-photo"
            className="h-56 w-full rounded-2xl object-cover shadow-md"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  </>
);

export default Contatti;
